import Modal from "@/components/ui/modal";
import ProductV2 from "@/modules/productv2";
import { TProduct } from "@/types/productv2";

type TProductDetailsModalProps = {
	isOpen: boolean;
	onClose: () => void;
	slug: string;
	product: TProduct;
};

const ProductDetailsModal = ({ isOpen, onClose, slug, product }: TProductDetailsModalProps) => {
	return (
		<Modal isOpen={isOpen} onClose={onClose} className="max-w-5xl">
			<ProductV2 productSlug={slug} product={product} />
		</Modal>
	);
};

export default ProductDetailsModal;
